import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@mcv-shared/mcv-app-header.css";
import "./index.css";
import { applyMailTheme, readMailTheme } from "@/lib/theme/mailTheme";
import { readMailAccent } from "@/lib/theme/mailAccent";
import {
  exposeMailDebugHelpers,
  installMailCacheGuard,
  syncMailBuildVersionOnLaunch,
} from "@/lib/cache/mailSwBootstrap";
import { startMailSuiteAuth, syncSuiteUserIdFromQuery } from "@/auth";
import App from "./App";

applyMailTheme(readMailTheme(), readMailAccent());
installMailCacheGuard();
exposeMailDebugHelpers();

syncSuiteUserIdFromQuery();
syncMailBuildVersionOnLaunch();
startMailSuiteAuth();

const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
